export default "__VITE_ASSET__BrQdt7Jp__"